import { render, staticRenderFns } from "./PersonalConsultation.vue?vue&type=template&id=a36700ba&"
import script from "./PersonalConsultation.vue?vue&type=script&lang=js&"
export * from "./PersonalConsultation.vue?vue&type=script&lang=js&"
import style0 from "./PersonalConsultation.vue?vue&type=style&index=0&id=a36700ba&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a36700ba')) {
      api.createRecord('a36700ba', component.options)
    } else {
      api.reload('a36700ba', component.options)
    }
    module.hot.accept("./PersonalConsultation.vue?vue&type=template&id=a36700ba&", function () {
      api.rerender('a36700ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PersonalConsultation.vue"
export default component.exports